import React from "react"
import { NextSeo } from "next-seo"
import styled from "styled-components"
import Layout from "~/components/Pages/Basic"
import Breadcrumbs from "~/components/Breadcrumbs"
import { INFORMATION_BASE_PATH } from "~/components/traffic-tickets/information/constants"

import Markdown from "~/components/Markdown"
import { cut } from "~/utilities/string"

const Padding = styled.div`
  margin: 1em 0 0 0;
`

const TrafficInformation = ({
  title,
  description,
  state,
  content
}) => {
  const stateName = state.longName.toLowerCase()
  return (
    <>
      <NextSeo title={`${title} | WinIt`} description={description} />
      <Layout>
        <Breadcrumbs levels={[
          { title: "Home", href: INFORMATION_BASE_PATH },
          { title: state.title, href: `${INFORMATION_BASE_PATH}/${stateName}-courts`, as:`${INFORMATION_BASE_PATH}/${stateName}-courts` },
          { title: cut(title, 50, "...") }
        ]}
        />
        <Markdown src={content} />
        <Padding />
      </Layout>
    </>
  )
}

export default TrafficInformation
